"use client";

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import Cookie from "js-cookie";

const cookiesStorage: StateStorage = {
  getItem: (name: string) => {
    return JSON.parse(Cookie.get(name) ?? "{}");
  },
  setItem: (name: string, value: string) => {
    Cookie.set(name, JSON.stringify(value), { expires: 1 });
  },
  removeItem: (name: string) => {
    Cookie.remove(name);
  },
};

const useUx = create(
  persist(
    (set, get) => ({
      showMetaBar: true,
      set,
      get,
    }),
    {
      name: "ux", // name of the item in the storage (must be unique)
      storage: cookiesStorage,
      // storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export default useUx;
